import { RemarkButton } from '@Components/IconButton';
import Remark from '@Components/Remark';
import { useDisclosure } from '@hooks/useDisclosure';
import { Box } from '@mui/material';
import { createPortal } from 'react-dom';
import { useWatch } from 'react-hook-form';
import { useGreenhouseForm } from '../../EsgGreenhouseFormProvider';
import { IPerformanceGhGasMgmtReportFormValues } from '../../EsgGreenhouseFormProvider/types';

export const PF_GH_GAS_MGMT_REPORT_REMARK_ID = 'pf_gh-gas-mgmt-report-remark';

const PerformanceGhgasMgmtRemark = () => {
  const { control, getValues } = useGreenhouseForm();

  const { remark } =
    getValues('performanceGhGasMgmtReport.performanceGhGasMgmt') ??
    ({} as IPerformanceGhGasMgmtReportFormValues);

  const [isRemarkOpen, { open, close }] = useDisclosure(!!remark);

  const pfGhGasMgmtReportRemarkEl = document.getElementById(
    PF_GH_GAS_MGMT_REPORT_REMARK_ID
  );

  const { completedSection } =
    useWatch({
      name: 'performanceGhGasMgmtReport',
      control,
    }) ?? {};

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  return (
    <>
      <RemarkButton onClick={open} disabled={isCompletedTh && isCompletedEn} />
      {isRemarkOpen &&
        pfGhGasMgmtReportRemarkEl &&
        createPortal(
          <Box mt={2}>
            <Remark
              onDelete={close}
              topic="ผลการดำเนินงานและผลลัพธ์ด้านการจัดการจัดการก๊าซเรือนกระจก"
              setOpen={open}
              fieldPath="performanceGhGasMgmtReport.performanceGhGasMgmt.remark"
              isCompletedEn={isCompletedEn}
              isCompletedTh={isCompletedTh}
            />
          </Box>,
          pfGhGasMgmtReportRemarkEl
        )}
    </>
  );
};

export default PerformanceGhgasMgmtRemark;
